// import { useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
// import { ArrowRight } from "lucide-react";

// import useTips from "../../hooks/useTips";


// const HealthTipsSection = () => {


//     const {
//         tips,
//         loading,
//         error
//     } = useTips();



//     const [active, setActive] = useState(0);



//     // Sanity already returns newest first
//     const latestTips = tips.slice(0, 2);



//     useEffect(() => {

//         if (latestTips.length <= 1) return;


//         const interval = setInterval(() => {

//             setActive((prev) =>
//                 (prev + 1) % latestTips.length
//             );

//         }, 5000);


//         return () => clearInterval(interval);


//     }, [latestTips.length]);




//     if (loading) {

//         return (
//             <section className="py-20 text-center">
//                 Loading health tips...
//             </section>
//         );

//     }



//     if (error || latestTips.length === 0) {

//         return null;

//     }




//     return (

//         <section className="py-20 bg-white">

//             <div className="max-w-7xl mx-auto px-6">



//                 {/* Heading */}

//                 <motion.div

//                     initial={{
//                         opacity: 0,
//                         y: 30
//                     }}

//                     whileInView={{
//                         opacity: 1,
//                         y: 0
//                     }}

//                     viewport={{
//                         once: true
//                     }}

//                     className="
//                         text-center
//                         max-w-2xl
//                         mx-auto
//                         mb-12
//                     "

//                 >

//                     <h2 className="
//                         text-3xl
//                         md:text-4xl
//                         font-bold
//                         text-gray-900
//                     ">
//                         Health Tips
//                     </h2>


//                     <p className="
//                         mt-4
//                         text-gray-600
//                     ">
//                         Helpful healthcare guides to help you make informed decisions.
//                     </p>


//                 </motion.div>




//                 {/* Desktop */}

//                 <div className="
//                     hidden
//                     md:grid
//                     md:grid-cols-2
//                     gap-2
//                 ">


//                     {
//                         latestTips.map((article, index) => (


//                             <motion.div

//                                 key={article._id}

//                                 initial={{
//                                     opacity: 0,
//                                     y: 30
//                                 }}

//                                 whileInView={{
//                                     opacity: 1,
//                                     y: 0
//                                 }}

//                                 whileHover={{
//                                     y: -8
//                                 }}

//                                 transition={{
//                                     duration: 0.5,
//                                     delay: index * 0.1
//                                 }}

//                                 viewport={{
//                                     once: true
//                                 }}

//                                 className={`
//                                     ${article.background || "bg-green-700"}
//                                     rounded-3xl
//                                     overflow-hidden
//                                     p-6
//                                     grid
//                                     grid-cols-2
//                                     items-center
//                                     shadow-lg
//                                 `}

//                             >



//                                 {/* Content */}

//                                 <div className="pr-6">


//                                     <h3 className="
//                                         text-3xl
//                                         font-bold
//                                         text-white
//                                         leading-tight
//                                     ">

//                                         {article.title}

//                                     </h3>



//                                     <p className="
//                                         mt-5
//                                         text-white/80
//                                         leading-relaxed
//                                     ">

//                                         {article.description}

//                                     </p>



//                                     <Link

//                                         to={`/tips?id=${article._id}`}

//                                         className="
//                                             group
//                                             inline-flex
//                                             items-center
//                                             gap-2
//                                             mt-8
//                                             text-white
//                                             font-semibold
//                                         "

//                                     >

//                                         Read More


//                                         <ArrowRight

//                                             size={18}

//                                             className="
//                                                 transition-transform
//                                                 duration-300
//                                                 group-hover:translate-x-1
//                                             "

//                                         />

//                                     </Link>


//                                 </div>




//                                 {/* Image */}

//                                 <div className="
//                                     flex
//                                     justify-end
//                                     items-center
//                                 ">


//                                     {
//                                         article.image?.asset?.url && (

//                                             <img

//                                                 src={
//                                                     article.image.asset.url
//                                                 }

//                                                 alt={article.title}

//                                                 className="
//                                                     w-64
//                                                     object-contain
//                                                 "

//                                             />

//                                         )
//                                     }


//                                 </div>



//                             </motion.div>


//                         ))
//                     }



//                 </div>






//                 {/* Mobile Slider */}

//                 <div className="
//                     md:hidden
//                     overflow-hidden
//                 ">


//                     <motion.div

//                         animate={{
//                             x: `-${active * 100}%`
//                         }}

//                         transition={{
//                             duration: 0.8,
//                             ease: "easeInOut"
//                         }}

//                         className="
//                             flex
//                         "

//                     >


//                         {
//                             latestTips.map((article) => (


//                                 <div

//                                     key={article._id}

//                                     className="
//                                         min-w-full
//                                         px-1
//                                     "

//                                 >

//                                     <div className={`
//                                         ${article.background || "bg-green-700"}
//                                         rounded-3xl
//                                         p-5
//                                         flex
//                                         items-center
//                                         shadow-lg
//                                     `}>


//                                         <div className="
//                                             w-3/5
//                                             pr-4
//                                         ">


//                                             <h3 className="
//                                                 text-lg
//                                                 font-bold
//                                                 text-white
//                                                 leading-snug
//                                             ">

//                                                 {article.title}

//                                             </h3>



//                                             <p className="
//                                                 mt-3
//                                                 text-sm
//                                                 text-white/80
//                                                 leading-relaxed
//                                             ">

//                                                 {article.description}

//                                             </p>



//                                             <Link

//                                                 to={`/tips?id=${article._id}`}

//                                                 className="
//                                                     group
//                                                     inline-flex
//                                                     items-center
//                                                     gap-2
//                                                     mt-5
//                                                     text-white
//                                                     font-semibold
//                                                 "

//                                             >

//                                                 Read More


//                                                 <ArrowRight

//                                                     size={16}

//                                                     className="
//                                                         transition-transform
//                                                         duration-300
//                                                         group-hover:translate-x-1
//                                                     "

//                                                 />

//                                             </Link>


//                                         </div>




//                                         <div className="
//                                             w-2/5
//                                             flex
//                                             justify-center
//                                             items-center
//                                         ">


//                                             {
//                                                 article.image?.asset?.url && (

//                                                     <img

//                                                         src={
//                                                             article.image.asset.url
//                                                         }

//                                                         alt={article.title}

//                                                         className="
//                                                             w-full
//                                                             max-w-[140px]
//                                                             object-contain
//                                                         "

//                                                     />

//                                                 )
//                                             }


//                                         </div>


//                                     </div>


//                                 </div>


//                             ))
//                         }


//                     </motion.div>


//                 </div>



//             </div>

//         </section>

//     );

// };


// export default HealthTipsSection;


import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import tips from "../../data/tips";

const HealthTipsSection = () => {
    const [active, setActive] = useState(0);

    const latestTips = [...tips].slice(-2).reverse();

    useEffect(() => {
        const interval = setInterval(() => {
            setActive((prev) => (prev + 1) % latestTips.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [latestTips.length]);


    return (
        <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-6">

                {/* Heading */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center max-w-2xl mx-auto mb-12"
                >
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                        Health Tips
                    </h2>

                    <p className="mt-4 text-gray-600">
                        Helpful healthcare guides to help you make informed decisions.
                    </p>
                </motion.div>


                {/* Desktop */}
                <div className="hidden md:grid md:grid-cols-2 gap-2">
                    {latestTips.map((article, index) => (
                        <motion.div
                            key={article.id}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            whileHover={{ y: -8 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            className={`${article.bg} rounded-3xl overflow-hidden p-6 grid grid-cols-2 items-center shadow-lg`}
                        >

                            {/* Content */}
                            <div className="pr-6">
                                <h3 className="text-3xl font-bold text-white leading-tight">
                                    {article.title}
                                </h3>

                                <p className="mt-5 text-white/80 leading-relaxed">
                                    {article.description}
                                </p>

                                <Link
                                    to={`/tips`}
                                    className="group inline-flex items-center gap-2 mt-8 text-white font-semibold"
                                >
                                    Read More

                                    <ArrowRight
                                        size={18}
                                        className="transition-transform duration-300 group-hover:translate-x-1"
                                    />
                                </Link>
                            </div>


                            {/* Image */}
                            <div className="flex justify-end items-center">
                                <img
                                    src={article.image}
                                    alt={article.title}
                                    className="w-64 object-contain"
                                />
                            </div>

                        </motion.div>
                    ))}
                </div>


                {/* Mobile Slider */}
                <div className="md:hidden overflow-hidden">
                    <motion.div
                        animate={{ x: `-${active * 100}%` }}
                        transition={{ duration: 0.8, ease: "easeInOut" }}
                        className="flex"
                    >
                        {latestTips.map((article) => (
                            <div key={article.id} className="min-w-full px-1">

                                <div className={`${article.bg} rounded-3xl p-5 flex items-center shadow-lg`}>

                                    {/* Content */}
                                    <div className="w-3/5 pr-4">
                                        <h3 className="text-lg font-bold text-white leading-snug">
                                            {article.title}
                                        </h3>

                                        <p className="mt-3 text-sm text-white/80 leading-relaxed">
                                            {article.description}
                                        </p>

                                        <Link
                                            to={`/tips`}
                                            className="group inline-flex items-center gap-2 mt-5 text-white font-semibold"
                                        >
                                            Read More

                                            <ArrowRight
                                                size={16}
                                                className="transition-transform duration-300 group-hover:translate-x-1"
                                            />
                                        </Link>
                                    </div>


                                    {/* Image */}
                                    <div className="w-2/5 flex justify-center items-center">
                                        <img
                                            src={article.image}
                                            alt={article.title}
                                            className="w-full max-w-[140px] object-contain"
                                        />
                                    </div>

                                </div>

                            </div>
                        ))}
                    </motion.div>
                </div>

            </div>
        </section>
    );
};

export default HealthTipsSection;